const invertedMessages = {
  'Pre-Launch Analytics': 'certs.prelaunch.title',
  Campaign: 'certs.prelaunch.campaign',
  close: 'certs.prelaunch.close',
  'No campaign ID provided. Please navigate here from a campaign record.':
    'certs.prelaunch.no.campaign.id',
  'Pre-Launch Analysis is disabled. Enable it in EcmConfig (PRELAUNCH_ENABLED=true) to use this feature.':
    'certs.prelaunch.feature.disabled',
  'You do not have permission to run Pre-Launch Analysis. Required role: Campaign Admin.':
    'certs.prelaunch.forbidden',
  'Loading pre-launch analytics…': 'certs.prelaunch.loading',
  'Back to dashboard': 'certs.prelaunch.back.to.dashboard',
  First: 'certs.prelaunch.pagination.first',
  Prev: 'certs.prelaunch.pagination.prev',
  Next: 'certs.prelaunch.pagination.next',
  Last: 'certs.prelaunch.pagination.last',
  'These results reflect your data as of {timestamp}.\nPre-Launch Analytics does not guarantee final campaign scope — data changes between this analysis and launch may cause variances.\nRe-run analysis before launching to reflect the latest data quality insights and other metrics.':
    'certs.prelaunch.notice',
  'the analysis run time': 'certs.prelaunch.notice.fallback.timestamp',
};

export default invertedMessages;
